import BaseComponent from "components/base-component"
import classNames from "classnames"
import Link from "@kaspernj/api-maker/build/link"
import PropTypes from "prop-types"
import React from "react"
import Routes from "shared/routes"
import {Subscription} from "models"
export default class ComponentsSubscriptionsLink extends BaseComponent {
  static defaultProps = {
    adminLayout: false,
    userLayout: false
  }

  static propTypes = {
    adminLayout: PropTypes.bool.isRequired,
    className: PropTypes.string,
    subscription: PropTypes.instanceOf(Subscription).isRequired,
    userLayout: PropTypes.bool.isRequired
  }

  render() {
    const {adminLayout, children, className, subscription, userLayout, ...restProps} = this.props
    const generatedClassName = classNames("components--subscriptions--link", className)

    if (adminLayout) {
      return (
        <Link className={generatedClassName} to={this.to()} {...restProps}>
          {children || subscription.name()}
        </Link>
      )
    }

    return (
      <span className={generatedClassName} {...restProps}>
        {children || subscription.name()}
      </span>
    )
  }

  to() {
    const {adminLayout, subscription} = this.p

    if (adminLayout) {
      return Routes.adminSubscriptionPath(subscription.id())
    }

    return "#"
  }
}
